import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { BiLogOut } from 'react-icons/bi';

import { IUserMenu } from '@/interfaces/interfaceUserMenu';
import userIcon from '../../../assets/images/user-header.png';

export const UserMenu = (props: IUserMenu) => {
  const { refCloseProfileCard, showPopover, setShowPopover, serviceHeader } =
    props;

  const IconProfile = () => {
    return (
      <div
        onClick={() => setShowPopover(!showPopover)}
        className="flex w-full h-full flex-row text-secondary-contrast-color-text  rounded-md hover:cursor-pointer ">
        <div className="flex h-full flex-row w-full justify-center content-center">
          <img src={userIcon} alt="Usuario" className="h-6 " />
          <ChevronDownIcon className=" h-6 w-6 stroke-slate-600 dark:stroke-[#839AE6]" />
        </div>
      </div>
    );
  };

  const RenderMenuOptions = () => {
    return (
      <ul className="absolute top-[61px] right-1 w-64 flex flex-col rounded-b-lg bg-white drop-shadow-2xl p-2">
        {/* Usuario */}
        <div className="flex flex-col w-full py-3  border-b ">
          <div className="flex justify-between items-center text-official_green cursor-pointer mb-2  border-b border-official_green shadow-2xl">
            <img src={userIcon} alt="Usuario" className="h-8 mr-2" />
            <BiLogOut
              className="h-7 w-7"
              onClick={() => serviceHeader.logout()}
            />
          </div>
          <div className="text-xs font-bold py-1 truncate h-8 ">
            <p className="ml-2 border-solid border-red">
              {`${serviceHeader.user?.firstName} ${serviceHeader.user?.lastName}`}
            </p>
          </div>
          <p className="text-xs ml-2">{serviceHeader.user?.email}</p>
          <p className="text-xs ml-2">{serviceHeader.user?.phone}</p>
          <p className="text-xs ml-2">{serviceHeader.user?.roleName}</p>
        </div>

        {/* Opciones */}
        <li
          className="cursor-pointer h-10 flex items-center px-2 border-b border-official_green"
          onClick={() => serviceHeader.openProfileModal()}>
          Mi cuenta
        </li>
        <li className="cursor-pointer h-10 flex items-center px-2  border-b border-official_green">
          Aviso de privacidad
        </li>
        <li className="cursor-pointer h-10 flex items-center px-2  border-b border-official_green">
          Términos y condiciones
        </li>
        <li className="flex justify-center items-center mt-4 text-xs text-gray-500">
          V {process.env.REACT_APP_APPVERSION}
        </li>
      </ul>
    );
  };
  return (
    <div ref={refCloseProfileCard} className=" flex flex-col w-full relative">
      {IconProfile()}
      {showPopover ? RenderMenuOptions() : null}
    </div>
  );
};
